import React from "react";
import "../index.css";
import backgroundUrl from "../../../img/about/crypto-defi-trading-multiple-tokens-background.svg";
import Feature1Img from "../../../img/about/crypto-defi-trading-multiple-tokens.png";
import styled from "@emotion/styled";
import { FlexBetweenContainer } from "containers/FlexBetweenContainer";
import { FeatureImage as FeatureImageOriginal } from "./elements/FeatureImage";
import { SectionContainer } from "./elements/SectionContainer";
import { SectionTitle } from "./elements/SectionTitle";
import { SectionDescription } from "./elements/SectionDescription";
import { useIsMobile } from "hooks/useDeviceType";

const TWITTER_URL =
  "https://twitter.com/bebop_dex/status/1536757363679666180?s=20&t=zLVl4A7rBiImegjRSQEkSg";

export interface Feature1Props {
  className?: string;
}

export const Feature1: React.FC<Feature1Props> = () => {
  return (
    // Section ID used as scrolling marker from clicking "Learn More" in Intro component
    <Section id="feature-1">
      <FlexBetweenContainer direction="column" style={{ paddingBottom: "10%" }}>
        <FeatureImage src={Feature1Img} alt="feature-1" />
        <SectionTitle>Trade multiple tokens, all at once</SectionTitle>
        <SectionDescription isMarginBottom={true}>
          Trade one-to-many or many-to-one, allowing you to save both time and fees. Get in and out
          of positions quickly.
        </SectionDescription>
        <div className="d-flex">
          <button
            type="button"
            className="home-btn btn-bebop-outline dark round"
            onClick={() => window.open(TWITTER_URL)?.focus()}
          >
            Read how it works
          </button>
        </div>
      </FlexBetweenContainer>
    </Section>
  );
};

// Sub-components

const Section = styled(SectionContainer)(() => {
  const isMobile = useIsMobile();
  return {
    backgroundImage: `url(${backgroundUrl})`,
    backgroundRepeat: "no-repeat",
    marginTop: isMobile ? 0 : "30%",
    position: "relative",
    zIndex: 100,
  };
});

const FeatureImage = styled(FeatureImageOriginal)(() => ({
  "@media screen and (min-width: 1280px) and (max-width: 1440px)": {
    marginTop: "12%",
  },
  "@media screen and (min-width: 769px) and (max-width: 1024px)": {
    marginTop: "15%",
  },
  "@media screen and (min-width: 390px) and (max-width: 768px)": {
    width: "85%",
  },
  "@media screen and (max-width: 576px)": {
    width: "100%",
  },
}));
